import { Accordion } from 'component-library'
import MarkdownText from '../MarkdownText/MarkdownText'

import './DatasetSampleTab.scss'

const DatasetSampleTab = ({
  features,
}: {
  features: readonly { title: string; content: string; type: string }[]
}) => {
  return (
    <section className="DatasetSampleTab" data-testid="dataset-sample-tab">
      <ul className="mt-12 mx-auto font-roboto">
        {features
          .filter((feature) => feature.type == 'SAMPLES')
          .map((feature, index) => {
            return (
              <li key={index}>
                <Accordion
                  itemTitle={feature.title}
                  isExpandedDefault={true}
                  itemContent={
                    <>
                      <MarkdownText text={feature.content} />
                      <hr className="mt-12 text-[#B4B4B4]" />
                    </>
                  }
                />
              </li>
            )
          })}
      </ul>
    </section>
  )
}

export default DatasetSampleTab
